<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="header-box clearfix">
          <div class="top-nav fleft" v-show="outShow">
            <nav-top ref="navTop"></nav-top>
          </div>
          <div class="top-nav fright">
            <div v-show="loginShow">
              <a href="javascript:;">客服热线：0512-65359917</a>
              <span class="sep">|</span>
              <a @click="showLogin()">登录</a>
              <span class="sep">|</span>
              <a @click="showReg()">注册</a>
            </div>
            <div v-show="outShow" >
              <a href="javascript:;">客服热线：0512-65359917</a>
              <span class="sep">|</span>
              <a @click="routeTrans('/')" v-text="userInfo.name"></a>
              <span class="sep">|</span>
              <a @click="loginOut()">退出登录</a>
            </div>
          </div>
        </div>
        <div class="main-top clearfix">
          <div class="left-logo fleft"><img src="../static/images/logo.png" width="144" height="53" alt=""></div>

          <!-- <nav-common2></nav-common2> -->

          <div class="right-brand fright"><img src="../static/images/brand.png" width="267" height="53" alt=""></div>
        </div>
      </el-header>
      <el-main class="dom-container">
        <router-view/>
      </el-main>
      <!-- <footer-dom ref="footerNav"></footer-dom> -->
    </el-container>
    <login-dom ref="logindom" @listlogin="showReg()" @listenChilder="is_login()"></login-dom>
    <reg-dom ref="regdom" @listreg="showLogin()" @listenChilder="is_login()"></reg-dom>
  </div>
</template>

<script>
import Vue from 'vue';
import LoginDom from '@/components/login/login'
import RegDom from '@/components/reg/reg'
import NavTop from '@/components/navtop/navtop'
import FooterDom from '@/components/footer/footer'
import NavCommon2 from '@/components/navtop/navcommon2'
export default {
  name: 'App',
  data () {
    return {
      loginShow: true,//控制登录/注册按钮的显示/隐藏
      outShow: false,//控制登录用户/退出按钮的显示/隐藏
      loginFlag: false,
      userInfo: {//记录用户信息
        avatar: '',
        name: '',
        account: ''
      },
    }
  },
  created () {
    this.is_login();
  },
  watch: {
    $route(to, from) {//监听路由切换
      this.nav(to.path);
    }
  },
  methods: {
    showReg() {//显示注册页面的同时隐藏登录页面
  		this.$refs.logindom.hide();
      this.$refs.regdom.show();
    },
    showLogin() {//显示登录页面的同时隐藏注册页面
      this.$refs.regdom.hide();
  		this.$refs.logindom.show();
    },
    loginplay() {//控制登录/注册按钮的显示/隐藏
      this.loginShow = !this.loginShow;
    },
    outplay() {//控制登录用户/退出按钮的显示/隐藏
      this.outShow = !this.outShow;
    },
    navtopShow() {//头部导航条显示
      this.$refs.navTop.show();
    },
    navtopHide() {//头部导航条隐藏
      this.$refs.navTop.hide();
    },
    nav(path) {
      this.$nextTick(() => {//在首页头部导航条显示，否则隐藏
        // if(path == '/' || path == '/Culture' || path == '/Introduction' || path == '/Join' || path == '/Fristagency' || path == '/Mypromote' || path == '/Personal' || path == '/Resources') {
        //   this.navtopShow();
        // }else {
        //   this.navtopHide();
        // }
        if(path == '/Culture' || path == '/Introduction' || path == '/Join' || path == '/Fristagency' || path == '/Mypromote' || path == '/Personal' || path == '/Resources') {
          this.navtopShow();
        }else {
          this.navtopHide();
        }
      })
    },
    is_login() {
      var _this = this;
  		this.$http({
  			method: 'get',
  			url: _this.$api + '/service/agent/is_login',
  		}).then(function(res){
  			if(res.data.code == 200) {
          _this.getInfo();
          _this.outplay();
          _this.loginplay();
          _this.loginFlag = true;
          //_this.$refs.footerNav.showNav();
          if(_this.$route.path == '/' || _this.$route.path == '/Culture' || _this.$route.path == '/Introduction' || _this.$route.path == '/Join' || _this.$route.path == '/Fristagency' || _this.$route.path == '/Mypromote' || _this.$route.path == '/Personal' || _this.$route.path == '/Resources') {
            _this.nav(_this.$route.path)
          }
  			} else if(res.data.code == 400){
          _this.loginFlag = false;
          //_this.$refs.footerNav.hideNav();
          _this.$refs.logindom.show();
        }
      });
    },
    getInfo() {
  		var _this = this;
  		this.$http({
  			method: 'get',
  			url: _this.$api + '/service/agent/user/info',
  		}).then(function(res){
  			if(res.data.code == 200) {
            let data = res.data.data;
            _this.userInfo.name = data.nickname;
            _this.userInfo.avatar = data.avatar;
  			} else {

  			}
  		})
  	},
    loginOut() {
  		var _this = this;
  		this.$http({
  			method: 'get',
  			url: _this.$api + '/service/agent/web_logout',
  		}).then(function(res){
  			if(res.data.code == 200) {
          _this.toast(res.data.data,'success');
          _this.outplay();
          _this.loginplay();
          /*_this.showLogin();*/
          _this.$router.push('/');
          _this.$refs.logindom.show();
  			} else {
  				_this.toast(res.data.data,'warning');
  			}
  		})
    },
    toast(message,type) {
        this.$message({
          message: message,
          type: type
        })
    },
    routeTrans(url) {
      var _this = this;
      if(_this.loginFlag) {
        _this.$router.push(url);
      } else {
        _this.toast('请先登录或注册','warning');
      }
    }
  },
  components: {
    LoginDom,
    RegDom,
    FooterDom,
    NavTop,
    NavCommon2
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  #app
    position: relative
    .dom-container
      width: 1336px
      margin: 0 auto
    .el-header
      position relative
      height: 140px !important
      background: none
      color:  #b0b0b0
      padding: 0
      &:before
        position absolute
        display block
        content ''
        width 100%
        height 40px
        background #333
        left 0
        top 0
      .header-box
        position: relative
        width: 1336px
        height: 40px
        margin: auto
      .top-nav
        height: 40px
        line-height: 40px
        overflow: hidden
        font-size: 12px
        a
          color: #b0b0b0
          cursor: pointer
          &:hover
            color: #fff
        .sep
          color: #424242
          margin: 0 0.5em
        .router-link-exact-active
          color: #fff
      .main-top
        width 1336px
        height 100px
        line-height 100px
        margin 0 auto
        background #fff
        .left-logo
          margin-left 50px
        .right-brand
          margin-right 120px
        img
          vertical-align middle
    .el-main
      padding 0
      background #fff
      overflow: hidden
    .el-footer
      line-height: 60px
      background: #b3c0d1
      text-align: center
</style>



// WEBPACK FOOTER //
// src/App.vue